import {parseInt as parseIntFp} from '@shared/helpers/string'

import {MerchantsState} from '@web/slices/merchants/slice'
import makeSlice from '@web/slices/merchants/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (_, {payload}) => {
            const {
                data: {merchantsByMerchantNo},
            } = payload
            const result: MerchantsState = {}
            Object.keys(merchantsByMerchantNo).forEach((merchantNoString) => {
                const merchants = merchantsByMerchantNo[merchantNoString]
                const merchantNo = parseIntFp(10, merchantNoString)
                if (merchants && merchantNo) {
                    result[merchantNo] = {
                        contactEmailAddress: merchants.contactEmailAddress,
                        contactEmailAddressExposed: merchants.contactEmailAddressExposed ?? false,
                        merchantId: merchants.merchantId,
                        merchantUrl: merchants.merchantUrl,
                        name: merchants.name,
                        /**
                         * personalCustomsCodeExposed는 C1에서 개인통관고유부호 영역 노출 로직에 사용하는 값입니다.
                         * C2에서는 미사용 스펙이어서 false로 강제 할당합니다.
                         * 참조: https://oss.fin.navercorp.com/payment-fe/order-web/issues/7126
                         */
                        personalCustomsCodeExposed: null,
                        type: merchants.merchantType,
                        unsupportedPaymentMethods: [],
                        relations: [],
                        isPointAccumulationAvailable: true,
                    }
                }
            })
            return result
        })
    },
})

export default slice.reducer
